import axios from "axios";

const FetchList = (params, config) => {
  return axios.get("/api/v1/automation/list", {
    params,
    ...config,
  });
};

const FetchInvoiceLines = (id) => {
  return axios.get(`/api/v1/automation/invoice/${id}/lines`);
};

const FetchInvoiceData = (id) => {
  return axios.get(`/api/v1/automation/invoice/${id}/data`);
};

const ApiAutomation = {
  FetchList,
  FetchInvoiceLines,
  FetchInvoiceData,
};

export default ApiAutomation;
